import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";
import { configureStore } from "./appStore";
import addAuthTokenInterceptor from "./api/addAuthTokenInterceptor";
import { Provider as StoreProvider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import ErrorBoundary from "./common/ErrorBoundary";
import Loader from "./common/Loader";
import { history } from "./routes/history";
import { setRuntimeStore } from "./store/runtime";

setRuntimeStore(configureStore.store);
addAuthTokenInterceptor(configureStore.store);
const AppWithStore = () => {
  return (
    <StoreProvider store={configureStore.store}>
      <PersistGate loading={<Loader />} persistor={configureStore.persistor}>
        <Router history={history}>
          <App />
        </Router>
      </PersistGate>
    </StoreProvider>
  );
};

const appRoot = (
  <ErrorBoundary>
    <Suspense fallback={<Loader />}>
      <AppWithStore />
    </Suspense>
  </ErrorBoundary>
);

ReactDOM.render(
  process.env.NODE_ENV === "development" ? appRoot : <React.StrictMode>{appRoot}</React.StrictMode>,
  document.getElementById("root")
);

if (process.env.NODE_ENV === "production") {
  console.log = () => {};
  console.error = () => {};
  console.debug = () => {};
  console.info = () => {};
  console.info = () => {};
  console.group = () => {};
  console.groupEnd = () => {};
  document.addEventListener("contextmenu", (e) => e.preventDefault());

  function ctrlShiftKey(e, keyCode) {
    return e.ctrlKey && e.shiftKey && e.keyCode === keyCode.charCodeAt(0);
  }

  document.onkeydown = (e) => {
    // Disable F12, Ctrl + Shift + I, Ctrl + Shift + J, Ctrl + U
    if (
      e.keyCode === 123 ||
      ctrlShiftKey(e, "I") ||
      ctrlShiftKey(e, "J") ||
      ctrlShiftKey(e, "C") ||
      (e.ctrlKey && e.keyCode === "U".charCodeAt(0))
    )
      return false;
  };
  // Disable right-click
}
